import { css } from '@emotion/react';
import colors from 'Themes/colors';

export const shopNowBtn = css({
    '@media(min-width: 300px)': {
        display: 'flex',

        '& .arrow': {
            width: 20,
            height: 20,
            marginTop: -7,
            marginLeft: 5,
            transition: 'margin-left ease 0.5s',
        },

        ':hover': {
            '& .arrow': {
                marginLeft: 25,
            },
        },
    },

    '@media(min-width: 1200px)': {
        display: 'flex',

        '& .arrow': {
            width: 25,
            height: 25,
            marginTop: -6,
            marginLeft: 5,
            transition: 'margin-left ease 0.5s',
        },

        ':hover': {
            '& .arrow': {
                marginLeft: 25,
            },
        },
    },

});

export const arrow = css({
    width: 25,
    height: 25,
    marginTop: -6,
    marginLeft: 5,
    transition: 'margin-left ease 0.5s',
    border: '1px solid white',
});
